import { FormSchema } from '@features/lci-report/components/form-schema';
import { getRsaSummaryDefaultText } from './default-text';
import { defaultValues } from '@features/lci-report/components/default-values';
import { RslReport } from '@features/campaigns/subdomains/rsl';

export const clientDefaultValues = (
  report: RslReport,
  campaignName: string
): FormSchema => {
  const rsaSummary = getRsaSummaryDefaultText(report, campaignName);

  return {
    ...defaultValues,
    campaignName,
    rsaSummary,
    rsaOverallResults: rsaSummary,
  };
};
